import { createReducer } from "reduxsauce"
import { Types as HistoryTypes } from "../../actions/app/history"
import { omit } from "lodash"

const INITIAL_STATE = {}
// output of path-to-regexp with following path '/:accountId/p/:portfolioId/(.*)?'
const PORTFOLIO_REGEX = /^(?:\/([^/#?]+?))\/p(?:\/([^/#?]+?))(?:\/(.*))?[/#?]?$/i

const handleNavigate = (state, action) => {
  const portfolioResult = PORTFOLIO_REGEX.exec(action.location.pathname)
  if (portfolioResult) {
    return {
      ...state,
      account: portfolioResult[1],
      portfolio: portfolioResult[2],
    }
  }

  return {
    ...state,
  }
}

const handleSelectAccount = (state, action) => {
  if (action.account) {
    return {
      ...state,
      accountId: action.account.id,
      account: action.account.alias,
      accountMeta: omit(action.account, ["id", "value"]),
    }
  }

  return {
    ...state,
  }
}

const handleSelectPortfolio = (state, action) => {
  if (action.portfolio) {
    return {
      ...state,
      portfolio: action.portfolio,
    }
  }

  return {
    ...state,
  }
}

export const HANDLERS = {
  [HistoryTypes.NAVIGATE]: handleNavigate,
  [HistoryTypes.SELECT_ACCOUNT]: handleSelectAccount,
  [HistoryTypes.SELECT_PORTFOLIO]: handleSelectPortfolio,
}

export const reducer = createReducer(INITIAL_STATE, HANDLERS)
